import angular from 'angular';
import {
  bcpDataService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editTestDialog from '../dialog.editTestDialog';
import editTestDocumentDialog from '../testDocuments/dialog.editTestDocumentDialog';
import controller from './test.controller';
import directive from './test.directive';
import testDocuments from '../testDocuments';


export default angular.module('app.components.advisory.bcp.test', [
  alerts,
  bcpDataService,
  confirmDialog,
  editTestDialog,
  editTestDocumentDialog,
  testDocuments,
  ssDialogService,
])
  .directive('bcpTest', directive)
  .controller('TestController', controller)
  .name;

console.log('app.components.advisory.bcp.test created');
